<template>
  <div class="product_box cart_product_box order_product_box flex-r-c-c">
    <div class="pro_info flex-r-s-c">
      <van-image width="2.56rem" height="1.92rem" :src="myinfo.iconUrl" />
      <div class="cart_pro_info">
        <div class="pro_name van-multi-ellipsis--l2">{{ myinfo.name }}</div>
        <div class="pro_brand_model van-ellipsis">{{ myinfo.brand }} | {{ myinfo.specifications }}</div>
        <!-- <div class="pro_tags">1</div> -->
        <div class="pro_bottom flex-r-sb-c">
          <div v-if="discount" class="pro_money">
            ￥
            <span style="font-size: 0.37rem;">{{ myinfo.showPrice === 0? myinfo.price :'详询客服' }}</span>
          </div>
          <div v-else class="pro_money">
            ￥
            <span style="font-size: 0.37rem;">{{ myinfo.showPrice === 0? myinfo.paidPrice :'详询客服' }}</span>
            <span class="orgin_price">￥{{ myinfo.price }}</span>
          </div>
          <div v-if="type === 2" class="pro_num_change">
            <van-stepper v-model="myinfo.priceNum" :step="myinfo.multiplyQuantity === 1 ? myinfo.minQuantity : 1"
                         :min="myinfo.minQuantity" integer input-width="1rem" button-size="0.5rem"
                         @change="changeNum"
            />
          </div>
          <div v-else class="pro_num_change_no" style="font-size: 0.39rem;">x
            {{ myinfo.priceNum || myinfo.buyNumber || myinfo.refundNum || myinfo.realNum }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    info: { type: Object, default: () => { } },
    type: { type: Number, default: 3 },
    discount: { type: Boolean, default: false }
  },
  data() {
    return {
      myinfo: this.info
    }
  },
  methods: {
    // 修改数量
    changeNum(val) {
      if (parseInt(val) > 0) { this.$emit('changeNum', val) }
    },
    // 更新价格
    updatePrice(price, paidPrice) {
      this.$set(this.myinfo, 'price', price)
      this.$set(this.myinfo, 'paidPrice', paidPrice)
    }
  }
}
</script>
